/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class TeamRole implements Serializable<TeamRole> {
    roleName: string;
    name: string;
    id: string;
    defaultCoCaptain: boolean = false;
    subjectTypeId: string;
    label: string;


    deserialize(input: any) {
        input.id && (this.id = input.id);
        input.roleName && (this.roleName = input.roleName);
        input.roleName && (this.name = input.roleName);
        input.roleName && (this.label = input.roleName);
        input.defaultCoCaptain && (this.defaultCoCaptain = input.defaultCoCaptain);
        input.subjectTypeId && (this.subjectTypeId = input.subjectTypeId);
        return this;
    }

    constructor() {
    }

}
